import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { HEIGHT_HEADER_ROW, STROKE_PARAM } from '../const';
import { RootState } from '../store';
import { RowGantType } from '../types';
import { GantGridDatePeriod } from './datePeriod/gantGridDatePeriod';
import GantGridColumn from './gantGridColumn';
import GantGridTodaySelected from './gantGridTodaySelected';

interface GantHeaderGridProps {
    rowsHeaderGant: RowGantType[];
    dates: any[];
}

const GantHeaderGrid: React.FC<GantHeaderGridProps> = ({ rowsHeaderGant, dates }) => {
    const widthColumn = useSelector<RootState, number>((state) => state.gant.widthColumn);
    const widthLeftHeader = useSelector<RootState, number>((state) => state.gant.widthLeftHeader);

    const renderHeaderLine = useMemo(
        () => (rowType: RowGantType) => {
            return (
                <line
                    key={`line-${rowType}`}
                    x1={0}
                    y1={HEIGHT_HEADER_ROW}
                    x2={dates.length * widthColumn}
                    y2={HEIGHT_HEADER_ROW}
                    {...STROKE_PARAM}
                />
            );
        },
        [dates.length, widthColumn],
    );

    const renderedRows = useMemo(() => {
        return rowsHeaderGant.map((row, index) => (
            <g key={row} transform={`translate(0, ${HEIGHT_HEADER_ROW * index})`}>
                <GantGridColumn
                    dates={dates}
                    rowType={row}
                    isShowText
                    heightRow={HEIGHT_HEADER_ROW}
                    widthLeftHeader={widthLeftHeader}
                    height={HEIGHT_HEADER_ROW}
                />
                {renderHeaderLine(row)}
                {(row === 'dayWeek' || row === 'day') && <GantGridTodaySelected typeGrid={'header'} />}
                <GantGridDatePeriod typeGrid={'header'} />
            </g>
        ));
    }, [rowsHeaderGant, dates, renderHeaderLine, widthLeftHeader]);

    return <>{renderedRows}</>;
};

export default React.memo(GantHeaderGrid);
